// extracted by mini-css-extract-plugin
module.exports = {"modal-sound":"modal-sound_modal-sound__3NK7H","modal-overlay":"modal-sound_modal-overlay__1FTRM"};